import React, { ReactNode } from 'react';
type PanelProps = {
  tone?: 'light' | 'navy';
  padding?: 'sm' | 'md' | 'lg' | 'none';
  className?: string;
  children: ReactNode;
};
const paddings: Record<NonNullable<PanelProps['padding']>, string> = {
  none: '',
  sm: 'p-6',
  md: 'p-8',
  lg: 'p-10'
};
export function Panel({
  tone = 'light',
  padding = 'md',
  className = '',
  children
}: PanelProps) {
  const surface = tone === 'navy' ? 'bg-navy-panel border border-white/10' : 'bg-white border border-line shadow-card';
  return <div className={`avoid-break rounded-2xl ${surface} ${paddings[padding]} ${className}`} data-id="element-195" data-mp="2bkls0ypdetzm">
      {children}
    </div>;
}